const o=(o,t,c,e)=>(n,p)=>{c&&n&&(t(n),e?.(o,[n],p))};export{o as handleCheckboxOnChange};
